/**
 * Reducer for the games show welcome alert tutorial. Triggers a show welcome alert tutorial as soon
 * as the user opens a the new times tables home screen.
 */

import { fromJS } from 'immutable';

import { SET_TUTORIALS_COMPLETED, RESET_TUTORIALS } from '../actions';

export const GAMES_SHOW_WELCOME_ALERT_TUTORIAL_KEY = 'games-shown-welcome-alert';

const INITIAL_STATE = fromJS({
    completed: false,

    // Enabled for new users by default
    active: true,
    state: null,
});

export function gamesShowWelcomeAlertTutorialReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;

        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(GAMES_SHOW_WELCOME_ALERT_TUTORIAL_KEY) !== -1) {
                return fromJS({
                    completed: true,
                    active: false,
                    state: null,
                });
            }
            break;
    }

    return state;
}
